import MessageIcon from "@mui/icons-material/Message";
import WhatsappOutboundMessageList from "./WhatsappOutboundMessageList";

export default {
  list: WhatsappOutboundMessageList,
  icon: MessageIcon,
  name: "whatsappOutboundMessages",
  label: "WhatsApp Message Log",
  options: { label: "WhatsApp Message Log" },
};
